// import axios from 'axios';
// Archivo actualizado por el Ing. Wuilmer Garcia 2019-11-27

// Estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default {
  // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
  namespaced: true,

  state: {
    id_colegio: 5,
    id_usuario: 1,
    nombre_colegio: "Colegio PRUEBA ",
    nombre_usuario: "ING MASTER API REST VUE JS ",
    ano_lectivo: 2,
    id_perfil: 1,
    id_pais: 1,
    menu_mini: false,
  },

  // cambia los estados de las variables principales
  mutations: {
    setConfig(state, conexion) {
      state.id_colegio = conexion.id_colegio;
      state.id_usuario = conexion.id_usuario;
      state.nombre_colegio = conexion.nombre_colegio;
      state.nombre_usuario = conexion.nombre_usuario;
      state.ano_lectivo = conexion.ano_lectivo;
      state.nombre_colegio = conexion.id_perfil;
      state.nombre_colegio = conexion.id_pais;
    },

    // activo o desactivo el menu mini;
    /* setMenuMini(state){
    state.menu_mini =! state.menu_mini
    } */
  },

  // crea una copía de los estado iniciales del store (state)
  getters: {},

  actions: {},
};
